import { Component, OnInit, EventEmitter, Inject, ChangeDetectionStrategy } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { FileUploader } from 'ng2-file-upload/ng2-file-upload';
import { ToastrService } from 'ngx-toastr';
import {DateAdapter} from '@angular/material/core';
import {TranslateService} from 'ng2-translate/ng2-translate';
import { GeneralService } from '../../../services/general.service';
import { ProvidersService } from '../../../services/providers.service';
import * as decode from 'jwt-decode';
//import { forEach } from '@angular/router/src/utils/collection';

@Component({
  selector: 'app-provider-modal',
  templateUrl: './provider-modal.component.html',
  styleUrls: ['./provider-modal.component.scss']
})
export class ProviderModalComponent implements OnInit {
  userToken: any;
  userId: any;
  type: any;
  info: any = {};
  provider: any;
  txtHead: string;
  loadBtn = false;
  typeUse: any;
  valUse: any;
  providerId: any;
  centroCosto60;
  centroCosto10;

  constructor(private toastr: ToastrService, private gralService: GeneralService, private provService: ProvidersService, public dialogRef: MatDialogRef<ProviderModalComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
    this.userToken =  localStorage.getItem('G13xTfsdf234TVsd23513ffdgFdf2352');
    const d = this.userToken.split('Bearer ');
    const tokenPayload = decode(d[1]);
    this.userId = tokenPayload.Id;
    this.providerId = this.data.provider;
    this.type = this.data.type;
    this.info = this.data.info;

    console.log("this.info %o", this.info);

    let centros = this.info.CentrosCostos;
    console.log(centros);
    if(centros.length > 0){
      for(let i = 0; i < centros.length; i++){
        if(centros[i].NoSociedad == "S060" ){
          this.centroCosto60 = centros[i].CentroCostos;
        }

        if(centros[i].NoSociedad == "S010" ){
          this.centroCosto10 = centros[i].CentroCostos;
        }
      }
    }

    if(this.type == 'difference'){
      this.txtHead = 'ACTIONS.DIFFIMP';

      if(this.info.UsarMonto){
        this.typeUse = 1;
      }else{
        this.typeUse = 2;
      }
    }
  }

  ngOnInit() {
  }

  selectType(type){
    if(type == 1){
      this.info.UsarPorcentaje = false;
    }else{
      this.info.UsarMonto = false;
    }
  }

  save(){
    this.loadBtn = true;
    this.info.IdProveedor = this.providerId;
    this.info.CentrosCostos = [{ NoSociedad: "S060",
                                CentroCostos: this.centroCosto60 },
                                { NoSociedad: "S010",
                                CentroCostos: this.centroCosto10 }]

    this.provService.sendDifferenceProv(this.providerId, this.info, this.userToken).then((data) => {
      if(data['EsValido']){
        this.toastr.success('Configuración guardada correctamente', 'Parámetros de Proveedor');
        this.dialogRef.close();
      }else{
        this.toastr.error(data['MensajeUsuario'], 'Parámetros de Proveedor');
        return;
      }
      this.loadBtn = false;
    }, (err) => {
      console.log(err);
      this.loadBtn = false;
      if(err.status == 401){
        this.gralService.actDeacUser(false);
      }
    });
  }

  genNewUser() {
    this.loadBtn = true;
    this.info.IdProveedor = this.providerId;

    this.provService.sendNewUser(this.providerId, this.info, this.userToken).then((data) => {
      if (data['EsValido']) {
        this.toastr.success(data['MensajeUsuario'] , 'Parámetros de Proveedor');
        //this.dialogRef.close();
      } else {
        this.toastr.error(data['MensajeUsuario'], 'Parámetros de Proveedor');
        return;
      }
      this.loadBtn = false;
    }, (err) => {
      console.log(err);
      this.loadBtn = false;
      if (err.status == 401) {
        this.gralService.actDeacUser(false);
      }
    });
  }


  onCloseCancel() {
    this.dialogRef.close();
  }

  onCloseConfirm() {
    this.dialogRef.close({ data: true });
  }

}
